module.exports = __webpack_public_path__ + "media/landing_work/home/images/stepper-flag-46722dc6225f0eab3aa10a4d48c8448e.png";